//#region src/constants/regex/index.ts
const REGEX_PLAYER_LICENSEY_KEY = /^[\d\w+_/=]{48,64}$/;
const REGEX_ACCOUNT_ID = /[a-z0-9]{8}/gim;
const REGEX_ACCOUNT_UUID = /^[\d\w-]{36}$/;
const REGEX_ANALYTICS_TOKEN = /^[\d\w+_]{22}$/;

//#endregion
export { REGEX_ACCOUNT_ID, REGEX_ACCOUNT_UUID, REGEX_ANALYTICS_TOKEN, REGEX_PLAYER_LICENSEY_KEY };